export default function isValidJSON(value?: string): value is string {
  try {
    if (JSON.parse(value)) {
      return true;
    }
  } catch {
    return false;
  }
}
